import { SetPasswordFlow } from './SetPasswordFlow'

/**
 * `/auth/callback` — landing page for the new-user invite email link.
 *
 * Invites are server-initiated (`inviteUserByEmail`), so there is no client-side
 * PKCE code_verifier. The shared {@link SetPasswordFlow} establishes the session
 * from a verifier-free `token_hash`+`type=invite` link (or a `#access_token`
 * already consumed by `detectSessionInUrl`) and then lets the invitee set their
 * initial password. Reachable WITHOUT an existing session — it must NOT sit
 * behind ProtectedRoute.
 */
export function AuthCallbackPage() {
  return (
    <SetPasswordFlow
      linkType="invite"
      cardTitle="Welcome to iCrop"
      formTitle="Set Your Password"
      formDescription="Choose a password to finish setting up your account"
      submitLabel="Set Password & Continue"
      successTitle="Account Ready"
      successMessage="Your password has been set successfully."
    />
  )
}
